var CommentCommandId;
( (function(CommentCommandId) {
    CommentCommandId["Add"] = "workbench.action.addComment";
    CommentCommandId["NextThread"] = "editor.action.nextCommentThreadAction";
    CommentCommandId["PreviousThread"] = "editor.action.previousCommentThreadAction";
    CommentCommandId["NextRange"] = "editor.action.nextCommentingRange";
    CommentCommandId["PreviousRange"] = "editor.action.previousCommentingRange";
    CommentCommandId["ToggleCommenting"] = "workbench.action.toggleCommenting";
    CommentCommandId["Submit"] = "editor.action.submitComment";
    CommentCommandId["Hide"] = "workbench.action.hideComment";
    CommentCommandId["CollapseAll"] = "workbench.action.collapseAllComments";
    CommentCommandId["ExpandAll"] = "workbench.action.expandAllComments";
    CommentCommandId["ExpandUnresolved"] = "workbench.action.expandUnresolvedComments";
})(CommentCommandId || (CommentCommandId = {})));
export { CommentCommandId };
